import { resourceExplorerViewBudgetsSelector } from "./resourceExplorerViewBudgetsSelector";
import { RootState } from "../../../store";
import { billingExplorerCurrentBudgetIdSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/chart/settings/billingExplorerCurrentBudgetIdSelector";

export const resourceExplorerViewCurrentBudgetSelector = (state: RootState) => {
  const id = billingExplorerCurrentBudgetIdSelector(state);
  const budgets = resourceExplorerViewBudgetsSelector(state);

  const foundBudget = budgets?.find((budget) => budget.id === id);
  return foundBudget ?? budgets?.at(0);
};
